import * as React from "react";
const permissionRefreshSubscribers: Set<() => void> = new Set();
export const refreshAllCustomerPermissions = (): void => {
  permissionRefreshSubscribers.forEach((callback) => {
    try {
      callback();
    } catch (err) {
      console.error("Error notifying customer permission subscriber", err);
    }
  });
};

export const useCustomerPermission = (permissionType: string) => {
  const [permitted, setPermitted] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [refreshTrigger, setRefreshTrigger] = React.useState<number>(0);

  const refresh = React.useCallback(() => {
    setRefreshTrigger((prev) => prev + 1);
  }, []);
  React.useEffect(() => {
    permissionRefreshSubscribers.add(refresh);
    return () => {
      permissionRefreshSubscribers.delete(refresh);
    };
  }, [refresh]);

  React.useEffect(() => {
    const fetchPermission = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `/get_customer_permissions?type=${encodeURIComponent(
            permissionType
          )}&_=${Date.now()}`,
          {
            cache: "no-store",
            headers: {
              "Cache-Control": "no-cache, no-store, must-revalidate",
              Pragma: "no-cache",
              Expires: "0",
            },
            credentials: "same-origin",
          }
        );
        const data = await response.json();
        setPermitted(data.resource);
      } catch (error) {
        console.error("Error getting permission", error);
        setPermitted(false);
      } finally {
        setLoading(false);
      }
    };

    fetchPermission();
  }, [permissionType, refreshTrigger]);

  return { permitted, loading, refresh };
};
